import { render, staticRenderFns } from "./LoginSdkAndroid.vue?vue&type=template&id=438a5e06&scoped=true&"
import script from "./LoginSdkAndroid.vue?vue&type=script&lang=js&"
export * from "./LoginSdkAndroid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438a5e06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('438a5e06')) {
      api.createRecord('438a5e06', component.options)
    } else {
      api.reload('438a5e06', component.options)
    }
    module.hot.accept("./LoginSdkAndroid.vue?vue&type=template&id=438a5e06&scoped=true&", function () {
      api.rerender('438a5e06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/views/LoginSdkAndroid.vue"
export default component.exports